/**
 * SSOT תצוגה: רק BASIC / PRO למשתמשי קצה (STARTER מקטלוג ישן → BASIC).
 */

export function normalizeAgentPackageCode(code) {
  const u = String(code || "").trim().toUpperCase();
  if (!u) return "";
  if (u === "STARTER" || u === "BASIC") return "BASIC";
  if (u === "PRO") return "PRO";
  if (u === "AGENCY") return "AGENCY";
  return u;
}

/** תווית עברית לכרטיס חבילה בדשבורד */
export function agentPackageLabelHe(code) {
  const n = normalizeAgentPackageCode(code);
  if (n === "PRO") return "PRO";
  if (n === "BASIC") return "BASIC";
  if (n === "AGENCY") return "סוכנות";
  if (n === "TRIAL") return "ניסיון 60 יום";
  return "לא הוגדרה חבילה";
}

/**
 * חברי צוות של מוביל Agency יורשים את חבילת הסוכנות בתצוגה.
 * סוכנים עצמאיים (לא חברי צוות Agency) נשארים עם BASIC / PRO / ריק.
 */
export function teamMemberPackageCodeForDisplay(
  memberPackageCode,
  { leadPackageCode, isAgencyTeam } = {},
) {
  const lead = normalizeAgentPackageCode(leadPackageCode);
  if (isAgencyTeam || lead === "AGENCY") {
    return "AGENCY";
  }
  return normalizeAgentPackageCode(memberPackageCode);
}
